import { buildEndpointUrl, payloadToQueryParamsUrl } from '@/_shared/helpers';
import { GenericGet } from '@/_shared/types';
import {
  API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_TEAMS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_TEAMS_TEAMID_MEMBERS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_MEMBERS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_TEAMS_TEAMID_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_ASSIGN_CHECK_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_ASSIGN_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_PATH_KEY,
} from '@/swagger/constants/anagraphics-keys';
import {
  API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_DEPARTMENTS_DEPARTMENTID_TEAMS_TEAMID_YEAR_YEAR_QUARTER_QUARTER_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_DEPARTMENTS_DEPARTMENTID_YEAR_YEAR_QUARTER_QUARTER_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_DEPARTMENTS_DEPARTMENTID_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_DEPARTMENTS_DEPARTMENTID_TEAMS_TEAMID_PATH_KEY,
} from '@/swagger/constants/credits-keys';

export const API_GET_DEPARTMENTS = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_PATH_KEY, {
    organizationId,
  });
};

export const API_POST_ASSIGN_CHECK = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_ASSIGN_CHECK_PATH_KEY, {
    organizationId,
  });
};

export const API_POST_ASSIGN_DEPARTMENT = (organizationId: string, departmentId: string) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_ASSIGN_PATH_KEY,
    {
      organizationId,
      departmentId,
    },
  );
};

export const API_POST_CREATE_DEPARTMENT = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_PATH_KEY, {
    organizationId,
  });
};

export const API_GET_DEPARTMENT_TEAMS = (organizationId: string, departmentId: string) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_TEAMS_PATH_KEY,
    {
      organizationId,
      departmentId,
    },
  );
};

export const API_GET_DEPARTMENT_TEAM_MEMBERS = (
  organizationId: string,
  departmentId: string,
  teamId: string,
  excludeMemberType?: ('departmentManager' | 'teamManager')[],
) => {
  const baseUrl = buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_TEAMS_TEAMID_MEMBERS_PATH_KEY,
    {
      organizationId,
      departmentId,
      teamId,
    },
  );
  return payloadToQueryParamsUrl({ excludeMemberType }, baseUrl);
};

export const API_GET_DEPARTMENT_MEMBERS = (
  organizationId: string,
  departmentId: string,
  queryParams: GenericGet<
    typeof API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_MEMBERS_PATH_KEY
  >['request']['query'],
) => {
  const baseUrl = buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_MEMBERS_PATH_KEY,
    {
      organizationId,
      departmentId,
    },
  );
  return payloadToQueryParamsUrl(queryParams, baseUrl);
};

export const API_GET_DEPARTMENT_TEAM_DETAILS = (
  organizationId: string,
  departmentId: string,
  teamId: string,
) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_DEPARTMENTS_DEPARTMENTID_TEAMS_TEAMID_PATH_KEY,
    {
      organizationId,
      departmentId,
      teamId,
    },
  );
};

export const API_GET_DEPARTMENTS_CREDITS = (
  organizationId: string,
  departmentId: string,
  year: number,
  quarter: number,
) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_DEPARTMENTS_DEPARTMENTID_YEAR_YEAR_QUARTER_QUARTER_PATH_KEY,
    {
      organizationId,
      departmentId,
      year,
      quarter,
    },
  );
};

export const API_GET_DEPARTMENT_TEAM_CREDITS = (
  organizationId: string,
  departmentId: string,
  teamId: string,
  year: number,
  quarter: number,
) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_DEPARTMENTS_DEPARTMENTID_TEAMS_TEAMID_YEAR_YEAR_QUARTER_QUARTER_PATH_KEY,
    {
      organizationId,
      departmentId,
      year,
      quarter,
      teamId,
    },
  );
};

export const API_GET_DEPARTMENTS_CREDITS_QUARTER = (
  organizationId: string,
  departmentId: string,
) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_DEPARTMENTS_DEPARTMENTID_PATH_KEY,
    {
      organizationId,
      departmentId,
    },
  );
};

export const API_GET_DEPARTMENT_TEAM_CREDITS_QUARTER = (
  organizationId: string,
  departmentId: string,
  teamId: string,
) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_CREDITS_QUARTER_DEPARTMENTS_DEPARTMENTID_TEAMS_TEAMID_PATH_KEY,
    {
      organizationId,
      departmentId,
      teamId,
    },
  );
};
